const TUS_FINGERPRINT_PREFIX = "mem-audio";
const TUS_FINGERPRINT_SEPARATOR = "::";

export function generateTusFingerprint(params: {
  audioRecordingId: string;
  filename: string;
  fileSize: number | "unknown";
  endpoint: string;
}): string {
  return [
    TUS_FINGERPRINT_PREFIX,
    params.audioRecordingId,
    params.filename,
    params.fileSize,
    params.endpoint,
  ].join(TUS_FINGERPRINT_SEPARATOR);
}

export function buildCombinedUploadErrorMessage({
  primaryError,
  priorTransportError,
}: {
  primaryError: string;
  priorTransportError: string | null;
}): string {
  if (!priorTransportError || priorTransportError.trim().length === 0) {
    return primaryError;
  }

  return `${primaryError} | prior transport error: ${priorTransportError}`;
}
